export const en = {
    Mancala: "Mancala",
    Leave: "Leave The Game",
    NewGame: "New Game",
    YourTurn: "Your Turn",
    OpponentTurn: "Opponent Turn",
    GameEnded: "Game Ended",
    InternalErrorOccurred: "An internal error has occurred",
    YouWon: "You Won",
    Won: "Won",
    YouLost: "You Lost",
    Connecting: "Connecting",
    Connected: "Connected",
    CannotConnect: "Can't Connect",
    ConnectionLost: "Network Connection Lost",
    ConnectingAgain: "Connecting Again",
    ServerError: "Server Error",
    SearchingOpponet: "Searching Opponet",
    OpponentLeftTheGame: "Opponent Leaves The Game",
    YouLeftTheGame: "You Left The Game",
    UserLeftTheGame: "Left The Game",
    SearchingOpponent: "Searching Opponent",
    PleaseWait: "Please Wait",
    GameDraw: "Draw",
    Anonymous: "Anonymous",
    GameNotFound: "Game Not Found",
    Loading: "Loading",
    Playing: "Playing",
    Error: "Error",
    ErrorWhenRetrievingInformation: "An error occured when retrieving information!",
    UCanOnlyPlayYourOwnPits: "You can only play your own pits",
    UMustWaitUntilCurrentMoveComplete: "You must wait until the current move is complete",
    UCanNotPlayEmptyPit: "You can not play empty pit",
    AreYouSureToLeaveGame: "Are you sure to leave game?",
    Yes: "Yes",
    Cancel: "Cancel",
    Help: "Help",
    WebApp: "Goto WebApp",
    Privacy: "Open Privacy Policy",
    Home: "Home",
    RejoinGame: "Rejoin Game",
    Guest: "Guest",
    LogIn: "Log In",
    SignUp: "Sign Up",
    LogOut: "Log Out",
    LiveGames: "Live Games",
    PopularGames: "Popular Games",
    MyRecentGames: "My Recent Games",
    NoGamesYet: "No games yet",
    Watching: "{{count}} watching",
    GameInProgress: "You have a game in progress",
    Continue: "Continue",
    Versus: "vs",
    Draw: "Draw",
    OpponentLeft: "Opponent left",
    YouLeft: "You left",
    OpponentTimedOut: "Opponent ran out of time",
    YouTimedOut: "You ran out of time",
    Abandoned: "Abandoned",
    PlayerWon: "{{name}} won",
    Moves: "Moves",
    PitNumber: "Pit {{pit}}",
    ExtraTurn: "Extra turn",
    Capture: "Capture",
    StoreGain: "+{{count}} to store",
    GameOver: "Game over",
    ViewingMove: "Viewing move {{number}}",
    MoveOf: "Move {{number}} / {{total}}",
    MoveNumber: "Move {{number}}",
    Start: "Start",
    BackToLive: "Back to live",
    WatchFromStart: "Watch from start",
    Speed: "Speed",
    Duration: "Duration",
    You: "You",
    Opponent: "Opponent",
    StoreCount: "Store {{count}}",
    Online: "Online",
    Offline: "Offline",
    ChooseTheme: "Choose theme",
    ThemeWalnut: "Walnut theme",
    ThemeNight: "Night theme",
    ThemeJade: "Jade theme",
    Account: "Account",
    NewestFirst: "newest first",
    BeingPlayedNow: "Being played now",
    MostWatched: "Most watched",
    YourGames: "Your games",
    GameWithOpponent: "Your game with {{name}} is on",
    StoreScores: "Your store {{mine}}, opponent's {{theirs}}",
    Live: "Live",
    Close: "Close",
    Play: "Play",
    Pause: "Pause",
    FirstMove: "Go to start",
    PreviousMove: "Previous move",
    NextMove: "Next move",
    LastMove: "Go to end",
    MovePosition: "Move position",
    PlaybackControls: "Playback controls",
    PlaybackSpeed: "Playback speed",
    GameSummary: "Game summary",
    StartPosition: "4 stones in every pit",
    MoveCount: "{{count}} moves",
    PitLabel: "{{name}}, pit {{pit}}, {{count}} stones",
    StoreLabel: "{{name}}'s store, {{count}} stones",
    OpenGame: "Open the game",
    Score: "Score",
    PlayWithBot: "Play with bot",
    NoOpponentYet: "No opponent yet. Play with the bot?",
    ChooseBotLevel: "Choose how strong the bot is",
    Bot: "Bot",
    BotLevelEasy: "Easy",
    BotLevelMedium: "Medium",
    BotLevelHard: "Hard",
    BotLevelMaster: "Master",
    PlayAgain: "Play again",
    RuleBoardTitle: "The board and the goal",
    RuleBoardText1: "Each player has the 6 pits on their side of the board and a store, the large pit at the end of their row. Every pit starts with 4 stones.",
    RuleBoardText2: "Stones that reach your store are yours. On your turn you play one of your pits, then it is the opponent's turn.",
    RuleBoardText3: "When the game ends, the player with more stones in their store wins. There are 48 stones, so 25 always win.",
    RuleSowingTitle: "Sowing",
    RuleSowingText1: "Take all the stones from one of your pits. Put the first back into the same pit and one into each pit after it, towards your store.",
    RuleSowingText2: "A pit with a single stone moves it to the next pit.",
    RuleSowingText3: "Your store gets a stone when you pass it; the opponent's store is skipped.",
    RuleExtraTurnTitle: "Extra turn",
    RuleExtraTurnText1: "If your last stone lands in your store, you play again.",
    RuleExtraTurnText2: "Count the stones: a pit whose stones end exactly in your store gives you another move.",
    RuleEvenCaptureTitle: "Capturing an even pit",
    RuleEvenCaptureText1: "If your last stone lands in one of the opponent's pits and makes the stones there even, you take all of them into your store.",
    RuleEvenCaptureText2: "If the number is odd, nothing is taken and the turn passes.",
    RuleEmptyPitCaptureTitle: "Capturing from an empty pit",
    RuleEmptyPitCaptureText1: "If your last stone lands in an empty pit of yours and the opponent's pit opposite has stones, you take that stone and all the stones opposite.",
    RuleEmptyPitCaptureText2: "If the pit opposite is empty, nothing is taken.",
    RuleEndOfGameTitle: "End of the game",
    RuleEndOfGameText1: "The game ends as soon as all pits on one side are empty.",
    RuleEndOfGameText2: "The player whose side is empty gets all the stones left on the other side.",
    RuleEndOfGameText3: "Then the stores are counted: more stones wins, the same number is a draw.",
    RuleClockTitle: "The clock",
    RuleClockText1: "Each player has 5 minutes for the whole game. Only the clock of the player whose turn it is runs.",
    RuleClockText2: "A player whose time runs out loses.",
    LessonTaskAnyMove: "Play one of your pits in the bottom row and watch the stones.",
    LessonTaskSowing: "Play any pit. Try the pit with a single stone too.",
    LessonTaskExtraTurn: "Find the pit whose last stone lands in your store.",
    LessonTaskEvenCapture: "Make one of the opponent's pits even with your last stone.",
    LessonTaskEmptyPitCapture: "End your move in your empty pit to take the stones opposite.",
    LessonTaskEndGame: "Play your last stone and see who gets the stones that are left.",
    MoveExplainExtraTurnYou: "Your last stone landed in your store: you play again.",
    MoveExplainExtraTurnBot: "The bot's last stone landed in its store: it plays again.",
    MoveExplainEvenYou: "Your last stone made an opponent's pit even: you took {{count}} stones.",
    MoveExplainEvenBot: "The bot's last stone made one of your pits even: it took {{count}} stones.",
    MoveExplainEmptyPitYou: "Your last stone landed in an empty pit of yours: you took it and the {{count}} stones opposite.",
    MoveExplainEmptyPitBot: "The bot's last stone landed in an empty pit of its own: it took it and your {{count}} stones opposite.",
    MoveExplainOddYou: "Your last stone left {{count}} stones in the opponent's pit, an odd number: nothing was taken and the turn passes.",
    MoveExplainOddBot: "The bot's last stone left {{count}} stones in your pit, an odd number: it took nothing.",
    MoveExplainOwnPitYou: "Your last stone landed in one of your pits that was not empty: the turn passes.",
    MoveExplainOwnPitBot: "The bot's last stone landed in one of its own pits: your turn.",
    MoveExplainEmptyOppositeYou: "Your last stone landed in an empty pit of yours, but the pit opposite was empty: nothing to take.",
    MoveExplainEmptyOppositeBot: "The bot's last stone landed in its empty pit, but your pit opposite was empty: it took nothing.",
    MoveExplainGameOver: "One side is empty, so the game is over.",
    HowToPlay: "How to play",
    LearnMangala: "Learn Mangala",
    Lessons: "Lessons",
    TryIt: "Try it",
    Hints: "Hints",
    HintExtraTurn: "Extra turn",
    HintCaptures: "Takes {{count}}",
    NewToMangala: "New to Mangala? Learn it in 3 minutes.",
    StartTutorial: "Start",
    NotNow: "Not now",
    PracticeGame: "Practice game",
    PracticeGameText: "Play the Easy bot with hints on.",
    WellDone: "Well done!",
    NextLesson: "Next lesson",
    TryAgain: "Try again",
    LessonDone: "Done",
    AllLessons: "All lessons",
    LessonNumber: "Lesson {{number}} of {{count}}",
    Rematch: "Rematch",
    No: "No",
    RematchWaiting: "Waiting for {{name}}…",
    RematchRequested: "{{name}} wants a rematch",
    RematchDeclined: "{{name}} declined the rematch",
    RematchWithdrawn: "{{name}} withdrew the rematch",
    RematchNoAnswer: "{{name}} did not answer",
    RematchRequestExpired: "The rematch request expired",
    RematchOpponentGone: "{{name}} is no longer here",
    RematchClosed: "A rematch is no longer possible",
    Series: "Series",
    SeriesScoreText: "Series: {{first}} {{firstWins}} – {{secondWins}} {{second}}",
    SeriesGameNumber: "Game {{number}}",
    SeriesCurrentGame: "Now",
    SeriesEarlierGames: "{{count}} earlier games",
    MovedFirst: "Moved first",
    EndedOnTime: "time",
    EndedByLeaving: "left",
    Settings: "Settings",
    Theme: "Theme",
    ThemeWalnutName: "Walnut",
    ThemeNightName: "Night",
    ThemeJadeName: "Jade",
    PlayBot: "Play the bot",
}